import toast from "react-hot-toast";
import handlePaymentSuccess from "./handlePaymentSuccess";
import SDK from "../../config";
import SubscriptionService from "../../services/subscriptionService";
export const handleSubmit = async (
  event,
  stripe,
  elements,
  email,
  // phone,
  zipcode,
  CardNumberElement,
  cardName,
  setPageLoader,
  navigate
) => {
  event.preventDefault();

  if (!stripe || !elements) {
    return;
  }

  const paymentOf = "iOS";
  const cardNumberElement = elements.getElement(CardNumberElement);

  if (!cardNumberElement) {
    console.error("CardNumberElement not found");
    return;
  }

  setPageLoader(true);

  try {
    const response = await SubscriptionService.checkSubscriptionStatus(email);
    if (response) {
      toast.error(
        "This email has an active subscription. Please change the email address."
      );
      setPageLoader(false);
    } else {
      const saveRegion = localStorage.getItem("region") || "us";
      const { currency } =
        SDK.REGION_CONFIG[saveRegion] || SDK.REGION_CONFIG["us"];
      const userData = {
        email,
        // phone,
        zipcode,
        paymentOf,
        regionCur: currency,
      };
      const response = await SubscriptionService.intializePayment(userData);
      if (!response && !response.client_secret) {
        toast.error("Failed to create payment intent.");
        setPageLoader(false);
        return;
      }

      const clientSecret = response.client_secret;
      const customerId = response.customer;

      // Confirm Payment
      const result = await stripe.confirmCardSetup(clientSecret, {
        payment_method: {
          card: cardNumberElement,
          billing_details: {
            name: cardName,
          },
        },
      });

      if (result.error) {
        console.error("Error confirming setup intent:", result.error.message);
      }
      if (result.error) {
        toast.error("Invalid Card Details");
      } else {
        if (result.setupIntent.status === "succeeded") {
          const paymentMethodType = "Debit Card";
          const platformUsed = "iOS";
          const paymentMethodId = result.setupIntent.payment_method;
          const setupIntentId = result.setupIntent.id;

          await handlePaymentSuccess({
            setupIntentId,
            paymentMethodId,
            paymentMethodType,
            cardHolderName: cardName,
            customerEmail: email,
            // customerPhone: phone,
            billingZipcode: zipcode,
            platformUsed,
            customerId,
            navigate,
          });

          toast.success("Payment Successful");

          // Clear local storage
          localStorage.removeItem("email");
          // localStorage.removeItem("phone");
          localStorage.removeItem("zipcode");
        }
      }
    }
  } catch (error) {
    console.error("Error processing payment:", error);
    toast.error("Payment failed. Please try again.");
  } finally {
    setPageLoader(false);
  }
};
